/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DialogRef } from '@ngneat/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Offer, ProductExtra } from 'rest-client';

@UntilDestroy()
@Component({
  selector: 'bkg-alternative-offer-dialog',
  templateUrl: './alternative-offer-dialog.component.html',
  styleUrls: ['./alternative-offer-dialog.component.scss'],
})
export class AlternativeOfferDialogComponent implements OnInit {
  constructor(public ref: DialogRef, private router: Router) {}
  body: string;
  description: string;
  price: number;
  name: string;
  alternativeName: string;
  showInfo = false;

  ngOnInit(): void {
    if (this.ref.data && this.ref.data['message']) {
      this.body = this.ref.data['message'] as string;
      this.description = this.ref.data['description'] as string;
      this.price = this.ref.data['alternative_product'][
        'total_price'
      ] as number;
      this.name = this.ref.data['alternative_product']['name'] as string;
      this.alternativeName = this.getAlternativeName(this.ref.data['offer']);
    }
  }

  getAlternativeName(offer: Offer): string | null {
    if (offer?.extras.length) {
      const productExtra = offer?.extras?.filter(
        (extra: ProductExtra) => +extra.service_type === 2
      );
      return productExtra[0] ? productExtra[0].name : null;
    }
    return null;
  }

  switchShowInfo(): void {
    this.showInfo = this.showInfo ? false : true;
  }

  onClickClose(): void {
    this.ref.close();
  }

  onClickBooking(): void {
    this.ref.close(true);
  }

  onClickRedirectStepTwo(): void {
    this.ref.close();
    this.router.navigate(['/products']);
  }
}
